import React from 'react';
import { SimpleGrid, Text, VStack } from '@wegroup/design-system';
import { InsurancePolicyPackage } from '../../../../../../types/AdvisoryReport';
import LabeledParamFallback from '../../../../../../../../common/src/components/label-param-fallback/LabelParamFallback';
import { useTranslation } from 'react-i18next';
import { toEuro } from '../../../../../../../../sales-conversation/src/utils/stringUtils';
import { format, isValid } from 'date-fns';

interface Props {
  data: InsurancePolicyPackage;
}

const InsurancePolicyPackageItemInfo: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const isSimulationPackage = data.insurance_policies[0]?.type === 'SIMULATION';
  const isTailoredPremium = data.insurance_policies.some(
    (policy) => policy.is_tailored_premium === true,
  );
  const dueDate =
    data.due_date && isValid(new Date(data.due_date))
      ? format(new Date(data.due_date), 'dd/MM')
      : undefined;
  const startDate = data.start_date
    ? format(new Date(data.start_date), 'dd/MM/yyyy')
    : undefined;

  return (
    <SimpleGrid pt="2" pb="4" columns={4} gridGap="4">
      <LabeledParamFallback
        label={t('ADVISORY-REPORTS_CURRENT-INSURANCE_OVERVIEW_PACKAGE-NR')}
      >
        {data.package_nr}
      </LabeledParamFallback>
      <LabeledParamFallback
        label={t(
          'ADVISORY-REPORTS_CURRENT-INSURANCE_OVERVIEW_INSURANCE-COMPANY',
        )}
      >
        {data.insurance_company}
      </LabeledParamFallback>
      {isSimulationPackage ? (
        <LabeledParamFallback label={t('Start date')}>
          {startDate}
        </LabeledParamFallback>
      ) : (
        <LabeledParamFallback
          label={t(
            'ADVISORY-REPORTS_CURRENT-INSURANCE_OVERVIEW_EXPIRATION-DATE',
          )}
        >
          {dueDate}
        </LabeledParamFallback>
      )}
      <LabeledParamFallback
        label={t('ADVISORY-REPORTS_CURRENT-INSURANCE_OVERVIEW_PREMIUM')}
      >
        {isTailoredPremium ? (
          <VStack align="flex-start" spacing="1">
            <Text textStyle="h6Headline" color="primary.main">
              {t('FLOWS_PRODUCTS_QUOTE_CUSTOM-QUOTE')}
            </Text>
            <Text textStyle="smallBody" color="gray.300">
              {t('FLOWS_PRODUCTS_QUOTE_ERROR_CALCULATION-FAILED')}
            </Text>
          </VStack>
        ) : (
          toEuro(data.premium) + ' / ' + t(data.payment_interval)
        )}
      </LabeledParamFallback>
    </SimpleGrid>
  );
};

export default InsurancePolicyPackageItemInfo;
